'use strict';

angular.module('webAgro1App')
  // eslint-disable-next-line max-lines-per-function, max-params
  .factory('RecomendadoAplicadoService', function($http, $filter) {
    return {
      //eslint-disable-next-line
      listRecomendadoAplicado: function(filters) {
        const params = {
          propriedade: filters.propriedade.id,
          gleba: (filters.gleba || {}).id || null,
          grupo: (filters.grupoInsumo || {}).id || null,
          atividade: (filters.atividade || {}).id || null,
          data_inicio: filters.dataInicial || null,
          data_fim: filters.dataFinal || null,
          operacao: (filters.operacao || {}).id || null
        };

        return $http.get(`${SERVER}/v1/dashboard/recomendado_aplicado`, { params: params });
      },

      //eslint-disable-next-line
      drawChart: function(ctx, produtos) {
        const tooltipLabel = function(tooltipItem, data) {
          let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          value = $filter('number')(value, 2);
          const unidade = data.unidades[tooltipItem.index];
          return `${value} ${unidade}`;
        };

        const data = {
          labels: [],
          unidades: [],
          datasets: []
        };

        const dataSetRecomendado = {
          label: 'Recomendado',
          backgroundColor: 'rgba(52, 152, 219, 0.8)',
          borderColor: 'rgba(52, 152, 219, 1)',
          data: []
        };

        const dataSetAplicado = {
          label: 'Aplicado',
          backgroundColor: 'rgba(241, 196, 15, 0.8)',
          borderColor: 'rgba(241, 196, 15, 1.0)',
          data: []
        };

        produtos.forEach(function(dados) {
          data.labels.push(dados.produto.descricao);
          data.unidades.push(dados.unidade.abreviatura.replace(/\s/g, ''));
          dataSetAplicado.data.push(parseFloat(dados.total_aplicado || 0));
          dataSetRecomendado.data.push(parseFloat(dados.total_recomendado || 0));
        });

        data.datasets = [dataSetRecomendado, dataSetAplicado];

        return new Chart(ctx, {
          type: 'bar',
          data: data,
          options: {
            maintainAspectRatio: false,
            title: {
              display: true,
              text: 'Recomendado x Aplicado'
            },
            scales: {
              xAxes: [{
                stacked: false,
                ticks: {
                  autoSkip: false
                }
              }],
              yAxes: [{
                stacked: false,
                ticks: {
                  suggestedMin: 0
                }
              }]
            },
            tooltips: {
              callbacks: {
                label: tooltipLabel
              }
            }
          }
        });
      }
    };
  });
